import Loading from 'components/Loading/Loading'
import PinLogin from 'views/Login/PinLogin/PinLogin'
import LoginWithUsername from 'views/Login/LoginWithUsername/LoginWithUsername'
import ROUTE from 'constant/route'
import { useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Grid, Link } from '@mui/material'
import useKeyInputPIN from 'hooks/useKeyInputPIN/useKeyInputPIN'
import React from 'react'
import { hasServerKey } from 'store/authCommon'
import { useLoginContext } from './LoginProvider'

const SLIDE_SPEED = 120

const SwitchLogin = React.forwardRef<
    any,
    { loading: boolean; isLoginWithEmail: boolean; setIsLoginWithEmail: any }
>(({ loading, isLoginWithEmail, setIsLoginWithEmail }, ref: any) => {
    const { keyInputRef } = useKeyInputPIN(!isLoginWithEmail)
    const { resetLoginError } = useLoginContext()

    const history = useHistory()

    const allowToLoginWithPin = hasServerKey()

    const ResetPassword = useCallback(
        () => (
            <Grid mt={1} item container justifyContent={'center'}>
                <Link
                    sx={{
                        cursor: 'pointer',
                        color: 'primary.contrastText',
                        textDecoration: 'none',
                    }}
                    onClick={() => history.push(ROUTE.REQUEST_RESET_PASSWORD)}
                >
                    Reset Password
                </Link>
            </Grid>
        ),
        [history],
    )

    const LoginMethod = useCallback(
        ({ _isLoginWIthEmail = true }) => {
            if (loading)
                return (
                    <Grid item style={{ padding: '20px' }}>
                        <Loading />
                    </Grid>
                )
            if (_isLoginWIthEmail)
                return (
                    <>
                        <Grid item>
                            <LoginWithUsername
                                onCancel={() => {
                                    if (ref && ref.current)
                                        ref.current.slidePrev(SLIDE_SPEED)
                                }}
                            />
                        </Grid>
                        {ResetPassword()}
                    </>
                )
            else {
                return (
                    <Grid item>
                        <PinLogin ref={keyInputRef} />
                    </Grid>
                )
            }
        },
        [keyInputRef, ResetPassword, ref, loading],
    )

    useEffect(() => {
        if (!allowToLoginWithPin) {
            setIsLoginWithEmail(true)
        }
    }, [allowToLoginWithPin, setIsLoginWithEmail])

    return allowToLoginWithPin ? (
        <Swiper
            centeredSlides={true}
            centerInsufficientSlides={true}
            onSlideChange={(e) => {
                resetLoginError()
                setIsLoginWithEmail(() =>
                    ref.current.activeIndex !== 0 ? true : false,
                )
            }}
            threshold={40}
            onSwiper={(sw) => (ref.current = sw)}
            speed={SLIDE_SPEED}
        >
            <SwiperSlide style={{ width: '100% !important' }}>
                <LoginMethod _isLoginWIthEmail={false} />
            </SwiperSlide>
            <SwiperSlide>
                <Grid item xs={12}>
                    <LoginMethod _isLoginWIthEmail={true} />
                </Grid>
            </SwiperSlide>
        </Swiper>
    ) : (
        <>
            <LoginWithUsername />
            {ResetPassword()}
        </>
    )
})

export default SwitchLogin
